import { IconMouse } from "@tabler/icons-react";
import { convertDateTime } from "../../../utils/common";
import Button from "../UI/Button";
import classes from "./TitlePackage.module.css";
import { useTranslation } from "react-i18next";
import { IconPhone } from "@tabler/icons-react";
import { Modal } from "antd";

const TitlePackage = ({ paymentExpired, usedPackageName, isTrial }) => {
  const { t } = useTranslation();
  const info = () => {
    Modal.info({
      title: 'LeapAI contact detail',
      content: (
        <div>
          <p style={{ margin: '1rem 0' }}>Phone: (+966)920035161</p>
          <p style={{ margin: '1rem 0' }}>Email: info@leapai.ai</p>
        </div>
      ),
      onOk() {},
    });
  };

  return (
    <div className={classes.container}>
      <div className={classes.button}>
        <Button
          radius
          color
          button={t("addPackage")}
          icon={<IconMouse size="18px" strokeWidth="2.5" />}
          onClick={() => window.open("/welcome", "_self")}
        />
      </div>
      <div className={classes.title}>{t("upgradeTitle")}</div>
      <div className={classes["sub-title"]}>
        <div>
          <span>{isTrial ? t("trialPackage") : t("usingPackage")}</span>
          <span className={classes["used-package"]}>{usedPackageName}</span>
        </div>
        <div>
          <span>{t("expired")}: </span>
          <span className={classes.expired}>
            {convertDateTime(paymentExpired)}
          </span>
        </div>
      </div>
      <div className={classes["modal-ctn"]}>
        <Button
          radius
          button={t("contact")}
          icon={<IconPhone size="18px" strokeWidth="2.5" />}
          onClick={info}
        />
      </div>
    </div>
  );
};

export default TitlePackage;
